
function pickPortalTypes(obj) {
  if (!obj) return [];
  if (Array.isArray(obj.portal_types)) return obj.portal_types;
  if (Array.isArray(obj.portalTypes)) return obj.portalTypes;
  if (Array.isArray(obj.associate_types)) return obj.associate_types;
  return [];
}

export function getAssociateTypes(userInfo) {
  if (!userInfo) return [];
  const ut = userInfo.user_type;

  if (ut === "associate" || ut === "student" || ut === "teacher") {
    return pickPortalTypes(userInfo);
  }

  const nested = pickPortalTypes(userInfo.associate);
  if (nested.length > 0) return nested;
  return pickPortalTypes(userInfo);
}

export function isOnlineSchoolCapability(userInfo) {
  return getAssociateTypes(userInfo).includes("online_school");
}

export function isStudentReportsCapability(userInfo) {
  const types = getAssociateTypes(userInfo);
  return types.includes("online_school") || types.includes("hifz_ul_quran");
}

export function isHifzUlQuranCapability(userInfo) {
  if (!userInfo) return false;
  return getAssociateTypes(userInfo).includes("hifz_ul_quran");
}

export function getStudentProgressNavLabel(userInfo) {
  return isHifzUlQuranCapability(userInfo) ? "Student Lessons" : "Students Reports";
}

export function getStudentProgressListHeading(userInfo) {
  return isHifzUlQuranCapability(userInfo) ? "Student Lessons List" : "Student Reports List";
}

export function getStudentProgressRecordNounTitleCase(userInfo) {
  return isHifzUlQuranCapability(userInfo) ? "Lesson" : "Report";
}

export function getStudentProgressRecordNounLowerCase(userInfo) {
  return isHifzUlQuranCapability(userInfo) ? "lesson" : "report";
}

export function isJamiaCapability(userInfo) {
  return getAssociateTypes(userInfo).includes("jamia");
}

export function isJamiaOrHifzUlQuranCapability(member) {
  const types = getAssociateTypes(member);
  return types.includes("jamia") || types.includes("hifz_ul_quran");
}

export function getAssociateTypesFromAssociate(associate) {
  return pickPortalTypes(associate);
}

export function getPortalTypesFromMember(member) {
  if (!member) return [];
  const fromArrays = getAssociateTypesFromAssociate(member);
  if (fromArrays.length > 0) {
    return fromArrays.map((t) => String(t).trim()).filter(Boolean);
  }
  const raw = member.portal_types ?? member.portalTypes;
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (trimmed.startsWith("[")) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.map((t) => String(t).trim()).filter(Boolean);
        }
      } catch {
        /* ignore */
      }
    }
    if (trimmed) return [trimmed];
  }
  return [];
}
